import React from "react"

const TTbullets = () => {
  const hrefSymbol = "#"

  return (
    <ul className="TTbullets">
      <li>
        <img
          className="TTbullets-icon"
          src="/images/Section3/manage-portfolio.svg"
          alt="Manage portfolio icon"
        />
        <div className="TTbullets-info">
          <h3>Manage your finances</h3>
          <h5>Keep track of your credit and debit in one unified interface</h5>
        </div>
      </li>
      <li>
        <img
          className="TTbullets-icon"
          src="/images/Section3/visual-presentation.svg"
          alt="Visual presentation icon"
        />
        <div className="TTbullets-info">
          <h3>Visual presentation of your finances</h3>
          <h5>Understand your transactions in an easy and intuitive way</h5>
        </div>
      </li>
      <li>
        <img
          className="TTbullets-icon"
          src="/images/Section3/maximum-security.svg"
          alt="Maximum security icon"
        />
        <div className="TTbullets-info">
          <h3>Maximum security and transparency</h3>
          <h5>Secure and private transactions powered by blockchain</h5>
        </div>
      </li>
      <li>
        <img
          className="TTbullets-icon"
          src="/images/Section3/multiple-platforms.svg"
          alt="Multiple platforms icon"
        />
        <div className="TTbullets-info">
          <h3>Support for multiple platforms</h3>
          <h5>
            Access your finances anytime, anywhere on{" "}
            <a href={hrefSymbol}>iOS</a> or <a href={hrefSymbol}>Android</a>
          </h5>
        </div>
      </li>
    </ul>
  )
}

export default TTbullets
